/**
 * Schemas definiendo qué campos tiene cada entidad editable desde admin.
 * type: 'text' | 'textarea' | 'number' | 'url' | 'select' | 'tags' | 'list'
 */
export const CONTENT_SCHEMAS = {
  projects: {
    label: 'Proyectos',
    singular: 'Proyecto',
    fields: [
      { key: 'title', label: 'Título', type: 'text', required: true },
      { key: 'description', label: 'Descripción', type: 'textarea', required: true },
      { key: 'image', label: 'URL Imagen', type: 'url' },
      { key: 'imageFile', label: 'Subir fotografía', type: 'image' },
      { key: 'category', label: 'Categoría', type: 'text' },
      { key: 'tags', label: 'Tags (coma separados)', type: 'tags' },
      { key: 'appUrl', label: 'URL App publicada', type: 'url' },
      { key: 'repoUrl', label: 'URL Repo (opcional)', type: 'url' },
      { key: 'order', label: 'Orden', type: 'number' },
      { key: 'published', label: 'Publicado', type: 'checkbox', default: true },
    ],
    columns: ['title', 'category', 'published'],
  },
  blog: {
    label: 'Blog',
    singular: 'Artículo',
    fields: [
      { key: 'title', label: 'Título', type: 'text', required: true },
      { key: 'slug', label: 'Slug URL', type: 'text', required: true },
      { key: 'excerpt', label: 'Resumen', type: 'textarea', required: true },
      { key: 'image', label: 'URL Imagen portada', type: 'url' },
      { key: 'category', label: 'Categoría', type: 'text' },
      { key: 'date', label: 'Fecha', type: 'text', placeholder: '01 May 2026' },
      { key: 'readTime', label: 'Tiempo lectura', type: 'text', placeholder: '5 min' },
      { key: 'tags', label: 'Tags', type: 'tags' },
      { key: 'body', label: 'Contenido (markdown/texto)', type: 'textarea', rows: 12 },
      { key: 'published', label: 'Publicado', type: 'checkbox', default: true },
    ],
    columns: ['title', 'category', 'date', 'published'],
  },
  testimonials: {
    label: 'Testimonios',
    singular: 'Testimonio',
    fields: [
      { key: 'name', label: 'Nombre', type: 'text', required: true },
      { key: 'role', label: 'Cargo', type: 'text' },
      { key: 'company', label: 'Empresa', type: 'text' },
      { key: 'quote', label: 'Cita', type: 'textarea', required: true },
      { key: 'rating', label: 'Valoración (1-5)', type: 'number', min: 1, max: 5, default: 5 },
      { key: 'order', label: 'Orden', type: 'number' },
      { key: 'published', label: 'Publicado', type: 'checkbox', default: true },
    ],
    columns: ['name', 'company', 'rating', 'published'],
  },
  faqs: {
    label: 'FAQs',
    singular: 'Pregunta',
    fields: [
      { key: 'question', label: 'Pregunta', type: 'text', required: true },
      { key: 'answer', label: 'Respuesta', type: 'textarea', required: true },
      { key: 'category', label: 'Categoría', type: 'text' },
      { key: 'order', label: 'Orden', type: 'number' },
      { key: 'published', label: 'Publicado', type: 'checkbox', default: true },
    ],
    columns: ['question', 'category', 'published'],
  },
  services: {
    label: 'Servicios',
    singular: 'Servicio',
    fields: [
      { key: 'title', label: 'Título', type: 'text', required: true },
      { key: 'desc', label: 'Descripción', type: 'textarea', required: true },
      { key: 'icon', label: 'Icono (lucide)', type: 'text', placeholder: 'ShieldAlert' },
      { key: 'order', label: 'Orden', type: 'number' },
      { key: 'published', label: 'Publicado', type: 'checkbox', default: true },
    ],
    columns: ['title', 'icon', 'published'],
  },
  cases: {
    label: 'Casos éxito',
    singular: 'Caso',
    fields: [
      { key: 'title', label: 'Título', type: 'text', required: true },
      { key: 'sector', label: 'Sector', type: 'text' },
      { key: 'description', label: 'Descripción', type: 'textarea', required: true },
      { key: 'image', label: 'URL Imagen', type: 'url' },
      { key: 'metric1_label', label: 'Métrica 1 - Etiqueta', type: 'text' },
      { key: 'metric1_value', label: 'Métrica 1 - Valor', type: 'text' },
      { key: 'metric2_label', label: 'Métrica 2 - Etiqueta', type: 'text' },
      { key: 'metric2_value', label: 'Métrica 2 - Valor', type: 'text' },
      { key: 'metric3_label', label: 'Métrica 3 - Etiqueta', type: 'text' },
      { key: 'metric3_value', label: 'Métrica 3 - Valor', type: 'text' },
      { key: 'published', label: 'Publicado', type: 'checkbox', default: true },
    ],
    columns: ['title', 'sector', 'published'],
  },
  team: {
    label: 'Equipo',
    singular: 'Miembro',
    fields: [
      { key: 'name', label: 'Nombre', type: 'text', required: true },
      { key: 'role', label: 'Cargo', type: 'text', required: true },
      { key: 'bio', label: 'Biografía', type: 'textarea' },
      { key: 'photo', label: 'URL Foto', type: 'url' },
      { key: 'linkedin', label: 'URL LinkedIn', type: 'url' },
      { key: 'email', label: 'Email', type: 'text' },
      { key: 'order', label: 'Orden', type: 'number' },
      { key: 'published', label: 'Publicado', type: 'checkbox', default: true },
    ],
    columns: ['name', 'role', 'published'],
  },
  partners: {
    label: 'Partners',
    singular: 'Partner',
    fields: [
      { key: 'name', label: 'Nombre', type: 'text', required: true },
      { key: 'logo', label: 'URL Logo (opcional)', type: 'url' },
      { key: 'url', label: 'URL Web (opcional)', type: 'url' },
      { key: 'order', label: 'Orden', type: 'number' },
      { key: 'published', label: 'Publicado', type: 'checkbox', default: true },
    ],
    columns: ['name', 'url', 'published'],
  },
};
